import dynamic from "next/dynamic";
import { ComponentConfig } from "@zapier/builder.io-kit";
import { iconNames } from "@zapier/design-system";

export const ctaCardConfig: ComponentConfig = {
  name: "CTACard",
  image: "",
  component: dynamic(() => import("./CTACard")),
  includeScrollTracking: true,
  category: "Pricing",
  canHaveChildren: false,
  inputs: [
    {
      name: "stateKey",
      type: "string",
      required: true,
      helperText:
        "An identifier that should match any other component(s) on the page that should cause this component to be updated.",
    },
    {
      name: "productID",
      type: "string",
      helperText:
        "The ID of the product whose price will be displayed; for example, tables-premium is the ID of the Tables Premium add-on.",
    },
    { name: "icon", type: "string", enum: ["", ...Object.keys(iconNames)] },
    {
      name: "title",
      type: "object",
      subFields: [
        { name: "text", type: "string" },
        {
          name: "tag",
          type: "string",
          enum: ["h1", "h2", "h3", "h4", "h5", "h6"],
        },
      ],
      defaultValue: {
        text: "Worflow plans",
        tag: "h1",
      },
    },
    {
      name: "description",
      type: "string",
      defaultValue:
        "Build precise workflows to automate your unique tasks. Free to try.",
    },
    { name: "priceDetails", type: "string", defaultValue: "Upgrade for" },
    {
      name: "primaryCTA",
      type: "object",
      subFields: [
        { name: "text", type: "string" },
        { name: "href", type: "string" },
      ],
      defaultValue: {
        text: "Try it free",
      },
    },
    {
      name: "secondaryCTA",
      type: "object",
      subFields: [
        { name: "text", type: "string" },
        { name: "href", type: "string" },
      ],
      defaultValue: {
        text: "See plans",
      },
    },
  ],
};
